import $ from 'jquery';
import pegaConnector from 'lib/pega-connector';
import ClubStore from 'framework/stores/ClubStore';
import Framework from 'framework';
import constants from 'lib/constants';
import ProfileStore from 'framework/stores/ProfileStore';
import appInsightsService from 'framework/services/appInsightsService';
import _ from 'lodash';
const pegaClass = '.pega-container';
const insightsEvent = 'PegaContainer';
var nbamServiceCtrl = null;

function callPegaService(nbamServiceCtrlParam, profileData, clubData, pegaDomElements){
	if(profileData.memberState && profileData.memberState === constants.memberState.authenticated || profileData.memberState === constants.memberState.remembered) {
		let containerArray = [];
		let configuredMemberId;
		console.log('Current Club Name: ' + clubData.name + ' Id: ' + clubData.id);
        //Compile the list of containers on the page
		_.each(pegaDomElements, function(element){
			if(element.id){
				containerArray.push(element.id);
				const pegaContainerConfig = $('#' + element.id + '-config').html();
				const configObject = !pegaContainerConfig ? {} : JSON.parse(pegaContainerConfig);
				if(configObject.memberId){
					configuredMemberId = configObject.memberId;
				}
			}
		});
		console.log('Container Array -> ' + containerArray);
		console.log('Previous page -> ' + document.referrer);
		console.log('Current location -> ' + window.location.href);
		console.log('Profile Member State ->' + profileData.memberState);
		if(profileData.memberDetails && profileData.memberDetails.memberId){
			console.log('Member Id -> ' + profileData.memberDetails.memberId);
			// Multi Container
			let targetMemberId = configuredMemberId;
			if(!targetMemberId){
				targetMemberId = profileData.memberDetails.memberId;
			}
			console.log('Using TargetMember Id ->' + targetMemberId);
			nbamServiceCtrlParam.getOffers(targetMemberId, _.join(containerArray, ','), 'Web', document.referrer, window.location.href, processPegaContainerCall, clubData.id, processAPIError);
		}
	}else{
		console.log('Unknown user state ->' + profileData.memberState);
	}
}
/*
*  This function is called when an API error is detected on the Pega Library, the error could come from a backend problem (HTTP 500)
*  or a timeout error from the service
*/
function processAPIError(eventObj) {
	const pegaDomElements = $(pegaClass);
	console.log('Processing API Error');
	console.log(' Error Source -> ' + eventObj.source);
	//Since we received an API error / timeout
	let errorProps = {};
	errorProps.event = 'apiError';
	errorProps.detials = eventObj.errorObj;
	errorProps.source = eventObj.source;
	errorProps.xhrStatus = eventObj.xhrStatus;
	appInsightsService.logInsightsEvent(insightsEvent, errorProps);
	_.each(pegaDomElements, function(element){
		if(element.id){
			processPegaContainerCall(element.id, {
				Status: 'Error',
				Message: 'API call error'
			});
		}
	});
}

/*
*  This is a generic function used to load an Experience fragment(XF) into a div referenced by a container ID using the URI of an XF (fragmentUri) that has already
*  been resolved.
*  There is an errorCallBackFunction that is used to report when there is an error loading the fragment
*/
function loadExperienceFragmentIntoContainer(targetContainer, fragmentUri, pegaObj, errorCallbackFunction){
	let targetFragmentUri = fragmentUri;
	if(Framework.global.lt.author){
		targetFragmentUri += '?wcmmode=disabled';
	}
	console.log('Loading XF Fragment for Container ->' + targetContainer + ' fragmentUri ->' + targetFragmentUri);
	$.ajax({
		url: targetFragmentUri,
		method: 'GET',
		success: function (data, textStatus, jqXHR ) {
			const containerElement = $('#' + targetContainer);
			containerElement.removeClass('hidden-xs-up');
			const contentDiv = targetContainer + '-content';
			containerElement.append('<div id="' + contentDiv + '" class="fadeIn fadeInBase"></div>');
			$('#' + contentDiv).html(data);
			const anchorLinksArray = containerElement.find('a');
			if(anchorLinksArray){
				_.each(anchorLinksArray, function(anchorElement){
					if($(anchorElement).hasClass('analytics-link')){
						$(anchorElement).attr('data-personalized', 'true');
					}
					$(anchorElement).on('click', function(){
						console.log('Clicked anchor ->' + $( this ).text());
						if(nbamServiceCtrl != null && pegaObj){
							let profileData = ProfileStore.getInitialData();
							if(profileData && profileData.memberDetails && profileData.memberDetails.memberId){
								console.log('container ' + targetContainer);
								console.log('About to send request to captureResponse ->' + profileData.memberDetails.memberId);
								nbamServiceCtrl.captureResponseLT( targetContainer, profileData.memberDetails.memberId, pegaObj);
							}
						}
					});
				});
			}
		},
		error: function (xhr, status, error) {
			console.log('Error while loading XF');
			errorCallbackFunction(xhr, status, error);
		}
	});
}

/*
*  This function is used to load the Default XF in a container if the container's configuration as a Default specified
*/
function loadDefaultExperienceFragmentIntoContainer(targetContainer, configObject, clubStore, memberId){
	if( configObject.useDefaultXf && configObject.defaultXfUri){
		console.log('\tLoading Default XF into Container -> ' + targetContainer);
		const defaultFragmentUri = configObject.defaultXfUri + '/' + clubStore.id;
		console.log('defaultXfUri -> ' + defaultFragmentUri);
		loadExperienceFragmentIntoContainer(targetContainer, defaultFragmentUri, null, function(xhr, status, error){
			let failureDefaultProps = {};
			failureDefaultProps.memberId = memberId;
			failureDefaultProps.containerId = targetContainer;
			failureDefaultProps.event = 'loadDefaultXfFailure';
			failureDefaultProps.xfPath = defaultFragmentUri;
			failureDefaultProps.xhrStatus = xhr.status;
			failureDefaultProps.detials = error;
			appInsightsService.logInsightsEvent(insightsEvent, failureDefaultProps);
			console.log('Exception loading Default XF from Configuration');
		});
	}else{
		console.log('\tContainer -> ' + targetContainer + ' NOT using default');
	}
}

/*
*  This function is called to process the results coming from the Pega API for a specific container on the page
*/
function processPegaContainerCall(containerId, resultObject, memberId){
	console.log('Processing Pega Container ==>' + containerId + ' \n' + JSON.stringify(resultObject));
    //Checking container configuration
	const pegaContainerConfig = $('#' + containerId + '-config').html();
	const configObject = !pegaContainerConfig ? {} : JSON.parse(pegaContainerConfig);
	console.log('\tuseDefaultXf for container ' + containerId + '->' + configObject.useDefaultXf);
	const clubStore = ClubStore.getInitialData();
	let fragmentUri = null;
	let insightProps = {};
	insightProps.event = 'processPegaContainerCall';
	insightProps.containerId = containerId;
	insightProps.memberId = memberId;
	let topResult = null;
	if(resultObject.Status === 'OK'){
		console.log('\tContainer Call OK');
		if(resultObject.RankedResults ){
			console.log('\tResponse contained Result Object');
			if(resultObject.RankedResults.length > 0){
				topResult = resultObject.RankedResults[0];
				const targetFragment = topResult.AEMExperienceFragmentURL;
				if(targetFragment && targetFragment.startsWith('/content/experience-fragments/')){
					fragmentUri = targetFragment;
					insightProps.validXf = true;
					console.log('\tSending full analytics data');
					window.appEventData = window.appEventData || [];
					window.appEventData.push({
						personalizationDetails: [{
							containerName: resultObject.ContainerName,
							group: topResult.Group,
							interactionId: topResult.InteractionID,
							issue: topResult.Issue,
							offerID: topResult.Identifier,
							offerName: topResult.Name,
							rank: topResult.Rank
						}],
						event: 'Personalization'
					});
				}else{
					insightProps.validXf = false;
					console.log('\tNot a valid experience Fragment ->>' + targetFragment);
				}
			}
		}else{
			console.log('\t No RankedResults found. Sending default to analytics');
			window.appEventData = window.appEventData || [];
			window.appEventData.push({
				personalizationDetails: [{
					offerID: 'Default'
				}],
				event: 'Personalization'
			});
		}
	}
	console.log('\tFragment Uri From Pega API -> ' + fragmentUri);
	if(fragmentUri){
		let finalFragmentUri = fragmentUri + '/' + clubStore.id;
		insightProps.xfPath = finalFragmentUri;
		insightProps.useDefault = configObject.useDefaultXf;
		console.log('\tRendering Fragment ->' + finalFragmentUri);
		appInsightsService.logInsightsEvent(insightsEvent, insightProps);
		loadExperienceFragmentIntoContainer(containerId, fragmentUri, topResult, function(xhr, status, error){
			let failureProps = {};
			failureProps.memberId = memberId;
			failureProps.containerId = containerId;
			failureProps.event = 'loadXfFailure';
			failureProps.xfPath = fragmentUri;			
			failureProps.xhrStatus = xhr.status;
			failureProps.detials = error;
			appInsightsService.logInsightsEvent(insightsEvent, failureProps);
			loadDefaultExperienceFragmentIntoContainer(containerId, configObject, clubStore, memberId);
		});
	} else{
		console.log('\tNo XF coming back from Pega');
		insightProps.useDefault = configObject.useDefaultXf;
		appInsightsService.logInsightsEvent(insightsEvent, insightProps);
		console.log('\tConfig Object Use default -> ' + configObject.useDefaultXf + '- ');
		loadDefaultExperienceFragmentIntoContainer(containerId, configObject, clubStore, memberId);
	}
}


function callPegaServiceWrapper(nbamServiceCtrlParam, profileData, pegaDomElements){
	const currentClubData = ClubStore.getInitialData();
	if(currentClubData.name){
		console.log('Club Store Initialized');
		callPegaService(nbamServiceCtrlParam, profileData, currentClubData, pegaDomElements);
	} else{
		console.log('Club Store NOT Initialized, waiting... ');
		var unsubClubStore = ClubStore.listen((newClubData) => {
			callPegaService(nbamServiceCtrlParam, profileData, newClubData, pegaDomElements);
			unsubClubStore();
		});
	}
}


$(() => {
	let pegaDomElements = $(pegaClass);
	// Create Defaults if variables are not available on the page.
	// Cover cases where code may be deployed but pages could still be cached
	const author = Framework.global.lt.author ? Framework.global.lt.author : false;
	const editMode = Framework.global.lt.editMode ? Framework.global.lt.editMode : false;
	if(pegaDomElements.length && (!author || (author && !editMode) )) {
		//Pega API Service
		nbamServiceCtrl = pegaConnector.getNBAMServiceControl('V2', true);
		nbamServiceCtrl.initialize(window.lt.api.apimUrl);
		let profileData = ProfileStore.getInitialData();
		if(profileData.initialized){
			console.log('Profile Initialized');
			callPegaServiceWrapper(nbamServiceCtrl, profileData, pegaDomElements);
		}else{
			console.log('Profile NOT Initialized, waiting....');
			var unsubProfile = ProfileStore.listen((profileDataObject) => {
				console.log('Done Waiting. calling Pega Service');
				callPegaServiceWrapper(nbamServiceCtrl, profileDataObject, pegaDomElements);
				unsubProfile();
			});
		}
	}
});

